import { FC, useMemo } from 'react';
import { articlePageSize } from '../../hooks/useClubArticles';
import SkeletonArticle from './SkeletonArticle';

const LoadingArticles: FC = () => {
  const items = useMemo(() => Array(articlePageSize).fill(0), []);

  return (
    <>
      {items.map((_, i) => (
        <SkeletonArticle key={i} />
      ))}
    </>
  );
};

export default LoadingArticles;
